exports.validatorTypes = {
  required: "required",
  optional: "optional",
  name: "name",
  image: "image",
  mobile: "mobile",
  timeStamp: "timeStamp",
  string: "string",
  isAlphanumeric: "isAlphanumeric",
  numeric: "numeric",
  number: "number",
  float: "float",
  isInteger: "isInteger",
  notnull: "notnull",
  decimal: "decimal",
  url: "url",
  email: "email",
  array: "array",
  arrayString: "arrayString",
  arrayUrl: "arrayUrl",
  bool: "bool",
  json: "json",
  date: "date",
  uuid: "uuid",
};
